export const SEARCH_KEY_LEVELS = [1, 2, 3, 4, 5];
const SEARCH_KEY_ASSET_VERSION = "20260719";

export const getSearchKeyIcon = (level) => {
  const numericLevel = Number(level);
  const safeLevel = SEARCH_KEY_LEVELS.includes(numericLevel) ? numericLevel : 1;
  return `/assets/search/key_level${safeLevel}.svg?v=${SEARCH_KEY_ASSET_VERSION}`;
};

export const SEARCH_KEY_ICONS = SEARCH_KEY_LEVELS.map(getSearchKeyIcon);
